﻿import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml, SafeStyle, SafeScript } from '@angular/platform-browser';
// import * as moment from 'moment';


@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(private _sanitizer: DomSanitizer) { }

    public transform(value: string, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
        switch (type) {
            case 'html':
                return this._sanitizer.bypassSecurityTrustHtml(value);
            case 'style':
                return this._sanitizer.bypassSecurityTrustStyle(value);
            case 'script':
                return this._sanitizer.bypassSecurityTrustScript(value);
            case 'url':
                return this._sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this._sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`Unable to bypass security for invalid type: ${type}`);
        }
    }
}

// @Pipe({ name: 'formatProfitLoss' })
// export class FormatProfitLossPipe implements PipeTransform {
//     transform(value: string): any {
//         if (value == '' || value == undefined)
//             return '';

//         var numberValue = parseFloat(value.replace("$", ""));
//         if (numberValue < 0.0) {
//             return "<font color='red'>(" + value + ")</font>";
//         }
//         return value;
//     }

// }